import { Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";
import Image from "next/image";

export const GridStyledHireBetter = styling(Grid)((props) => ({
  width: "100%",
  padding: props?.isEvent ? "0px" : "32px 100px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginBottom: "0px",
  borderTop: "0.8px solid #AEAEAE",
  borderBottom: "0.8px solid #AEAEAE",
  justifyContent: "space-between",
  position: "relative",
  ...(props.isEvent
    ? {
        maxHeight: "264px",
        justifyContent: "center",
        height: "264px",
        overflow: "hidden",
      }
    : {}),

  [props.theme.breakpoints.down("lg")]: {
    padding: "24px",
    ...(props.isEvent
      ? {
          maxHeight: "unset",
          justifyContent: "center",
          height: "100%",
          overflow: "hidden",
        }
      : {}),
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "40px 24px",
    marginBottom: "0px",
    ...(props.isEvent
      ? {
          padding: "24px",
        }
      : {}),
  },

  [props.theme.breakpoints.down("sm")]: {
    ...(props?.isEvent
      ? {
          minHeight: "472px",
          padding: "8px 24px",
        }
      : {}),
  },
}));

export const HireBetterTitle = styling(Grid)((props) => ({
  color: props.isEvent ? "#BE4242" : "#FFF",
  fontFamily: "Manrope",
  fontSize: "60px",
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "70px",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "42px",
    lineHeight: "45px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "32px",
    lineHeight: "41.6px",
    fontWeight: "600",
  },
}));

export const HireBetterCard = styling(Grid)((props) => ({
  backgroundColor: props?.isEvent ? "transparent" : "white",
  padding: props?.isEvent ? "0px" : "16px 40px 16px 20px",
  display: "flex",
  flexDirection: "row",
  gap: props?.isEvent ? "130px" : "40px",
  width: "100%",
  borderRadius: "16px",
  alignItems: "center",
  border: props?.isEvent ? "transparent" : "2px solid #FFF",

  [props.theme.breakpoints.down("lg")]: {
    // width: "720px",
    gap: props?.isEvent ? "90px" : "28px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: props?.isEvent ? "45px" : "16px",
    flexDirection: "column",
    height: "auto",
    padding: props?.isEvent ? "0px" : "16px",
    alignItems: "center",
  },
}));

export const HireBetterUpperContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: props?.isEvent ? "column" : "row",
  gap: props?.isEvent ? "24px" : "40px",
  width: "auto",
  justifyContent: "space-between",
  width: "100%",
  alignItems: props?.isEvent ? "flex-start" : "center",

  [props.theme.breakpoints.down("lg")]: {
    gap: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
  },

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "center",
    ...(props?.isEvent
      ? {
          gap: "24px",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }
      : {}),
  },
}));

export const HireBetterLowerContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    gap: "16px",
    height: "100%",
    justifyContent: "space-between",
  },

  [props.theme.breakpoints.down("tablet")]: {},
}));

export const HireBetterEventName = styling(Typography)((props) => ({
  color: props?.isRaya ? "#2A714D" : "rgba(0, 0, 0, 0.87)",
  fontSize: "20px",
  fontWeight: props?.isEvent ? "700" : "600",
  lineHeight: "24px",
  fontFamily: "Inter",
  letterSpacing: props?.isEvent ? "0.3px" : "unset",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "16.8px",
    letterSpacing: "0.21px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
  },
}));

export const HireBetterEventHeadline = styling(Typography)((props) => ({
  fontSize: props?.isEvent ? "32px" : "28px",
  fontWeight: props?.isEvent ? "700" : "600",
  lineHeight: props?.isEvent ? "normal" : "33.6px",
  fontFamily: "Inter",
  color: props?.isEvent ? "rgba(255, 255, 255, 0.87)" : "#512ACC",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props?.isEvent ? "20px" : "20px",
    lineHeight: props?.isEvent ? "normal" : "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props?.isEvent ? "20px" : "16px",
    fontWeight: props?.isEvent ? "700" : "600",
    lineHeight: props?.isEvent ? "normal" : "24px",
    textAlign: "center",
  },
}));

export const HireBetterEventDescription = styling(Typography)((props) => ({
  fontSize: props?.isEvent ? "24px" : "20px",
  fontWeight: props?.isEvent ? "400" : "500",
  lineHeight: props?.isEvent ? "normal" : "30px",
  fontFamily: "Inter",
  color: props?.isEvent ? "rgba(255, 255, 255, 0.87)" : "rgba(0, 0, 0, 0.87)",
  "& p": {
    margin: 0,
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props?.isEvent ? "20px" : "16px",
    lineHeight: props?.isEvent ? "normal" : "19.2px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props?.isEvent ? "20px" : "14px",
    lineHeight: props?.isEvent ? "normal" : "21px",
    textAlign: "center",
  },
}));

export const HireBetterEventDetails = styling(Typography)((props) => ({
  fontSize: "20px",
  fontWeight: "400",
  lineHeight: "24px",
  fontFamily: "Inter",
  color: "#512ACC",
  margin: "0px !important",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "16px",
    lineHeight: "19.2px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "14px",
    lineHeight: "16.8px",
  },
}));

export const HireBetterCTA = styling(Button)((props) => ({
  display: "flex",
  minWidth: "300px",
  width: "fit-content",
  padding: props?.isEvent ? "6px 24px" : "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: props?.isEvent
    ? "#FFE36A"
    : "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  color: props?.isEvent ? "#FFF" : "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  borderRadius: "10px",
  height: props?.isEvent ? "72px" : "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    backgroundColor: props?.isEvent ? "#FFE36A" : "#FFDA07",
  },

  [props.theme.breakpoints.down("lg")]: {
    height: props?.isEvent ? "56px" : "48px",
    padding: props?.isEvent ? "5px 19px" : "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
    minWidth: "240px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
    maxWidth: "unset",
    letterSpacing: "0.1px",
  },
}));

export const HireBetterButtonContainer = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "flex-end",
  // width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    justifyContent: "flex-start",
  },

  [props.theme.breakpoints.down("tablet")]: {
    justifyContent: "center",
    width: "100%",
  },
}));

export const HireBetterImage = styling(Image)((props) => ({
  maxWidth: props?.isEvent ? "375px" : "167px",
  width: "100%",
  height: props?.isEvent ? "375px" : "167px",
  borderRadius: "16px",
  objectFit: "cover",
  minWidth: props?.isEvent ? "375px" : "167px",
  border: props?.isEvent ? "none" : "0.5px solid rgba(0, 0, 0, 0.24)",
  zIndex: props?.isEvent ? 1 : 0,

  [props.theme.breakpoints.down("lg")]: {
    // minWidth: "364px",
    // maxWidth: "364px",
    ...(props?.isEvent
      ? {
          maxWidth: "240px",
          minWidth: "240px",
          height: "240px",
        }
      : {}),
  },

  [props.theme.breakpoints.down("tablet")]: {
    minWidth: "0",
    maxWidth: "none",
    justifyContent: "center",
    height: "167px",
    width: "100%",
    ...(props?.isEvent
      ? {
          maxWidth: "240px",
          minWidth: "240px",
          height: "145px",
        }
      : {}),
  },
}));

export const HireBetterOuterCard = styling(Grid)((props) => ({
  width: "100%",
  margin: "auto",
  maxWidth: "1240px",
  gap: "8px",
  display: "flex",
  flexDirection: "column",

  [props.theme.breakpoints.down("lg")]: {
    gap: "16px",
    ...(props?.isEvent ? { gap: "45px" } : {}),
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "24px",
    ...(props?.isEvent ? { gap: "45px" } : {}),
  },
}));

export const HireBetterDecoTopLeft = styling("img")((props) => ({
  position: "absolute",
  zIndex: 0,
  pointerEvents: "none",
  top: "-25px",
  left: "-110px",
  width: "550px",
  height: "550px",
  transform: "rotate(260deg)",

  [props.theme.breakpoints.down("lg")]: {
    top: "-50px",
    left: "-235px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    top: "-375px",
    left: "-190px",
    transform: "rotate(0deg)",
  },
}));

export const HireBetterDecoTopRight = styling("img")(() => ({
  position: "absolute",
  top: "0px",
  right: "0px",
  width: "170px",
  height: "170px",
  zIndex: 0,
  pointerEvents: "none",
}));

export const HireBetterDecoBottomLeft = styling("img")(() => ({
  position: "absolute",
  bottom: "0px",
  left: "0px",
  width: "150px",
  height: "150px",
  zIndex: 2,
  pointerEvents: "none",
}));

export const HireBetterDecoBottomRight = styling("img")(() => ({
  position: "absolute",
  bottom: "0px",
  right: "0px",
  width: "150px",
  height: "150px",
  zIndex: 2,
  pointerEvents: "none",
}));

export const MerdekaBannerWrapper = styling("button")(() => ({
  display: "block",
  width: "100%",
  maxWidth: "1440px",
  margin: "0 auto",
  padding: 0,
  border: "none",
  background: "transparent",
  cursor: "pointer",
  lineHeight: 0,
}));

export const MerdekaBannerImage = styling("img")(() => ({
  width: "100%",
  height: "auto",
  display: "block",
  objectFit: "contain",
}));
